import { mt } from '@passionware/monads';
import { promiseState } from '@passionware/platform-react';
import { createContext, useContext } from 'react';
import { AsyncButton } from 'v5/patterns/forms/fields/AsyncButton';
import { startMutation } from 'v5/platform/react/startMutation';

/** Closes the picker dialog around a commit; none in a split-view column, which stays. */
export const ResourcePickerCloseContext = createContext<(() => void) | null>(
  null
);

/**
 * The picker's primary action: saves the pick and, in a dialog, closes it once saved. A failed
 * save keeps the dialog and the pick, and says so before the button.
 */
export function ResourcePickerCommit({
  label,
  onCommit,
  failure
}: {
  label: string;
  /** Saves the pick; null while there is nothing to save yet. */
  onCommit: (() => Promise<void>) | null;
  /** What the failed save says. */
  failure: string;
}) {
  const close = useContext(ResourcePickerCloseContext);
  const committing = promiseState.useMutation(
    async (save: () => Promise<void>) => {
      await save();
      close?.();
    }
  );
  return (
    <>
      {mt.isInError(committing.state) && (
        <p role="alert" className="text-sm text-fg-danger">
          {failure}
        </p>
      )}
      {/* the spinner covers the save, and a second click waits for it */}
      <AsyncButton
        type="button"
        variant="primaryAlt"
        size="sm"
        mutation={committing.state}
        disabled={onCommit === null}
        onClick={() => onCommit && startMutation(committing, onCommit)}
      >
        {label}
      </AsyncButton>
    </>
  );
}
